var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _vm.default_import
            ? _c("j-import-file", {
                attrs: {
                  "href-sample": require("@/assets/file/FORMAT_FLOW_IMPORT.zip")
                },
                on: { "import-data": _vm.importData }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.is_error
            ? _c(
                "b-button",
                {
                  staticClass: "btn outline red",
                  on: {
                    click: function($event) {
                      _vm.$refs.modalFlow.show()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-close" }),
                  _vm._v("\n      OPEN ERROR DATA\n    ")
                ]
              )
            : _vm.data_import
            ? _c(
                "b-button",
                { staticClass: "btn green", on: { click: _vm.uploadData } },
                [_vm._v("\n      UPLOAD\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-modal",
            {
              ref: "modalFlow",
              staticClass: "mod-form",
              attrs: { centered: "" }
            },
            [
              _c("h3", { staticClass: "float-to-center c--red" }, [
                _vm._v("\n        Error Data\n      ")
              ]),
              _vm._v(" "),
              _vm.error_data[0]
                ? _c("v-client-table", {
                    staticClass: "jTable",
                    attrs: {
                      data: _vm.error_data,
                      columns: _vm.column,
                      options: _vm.option
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "ERROR",
                        fn: function(props) {
                          return _c(
                            "div",
                            {},
                            _vm._l(props.row.ERROR, function(err, index) {
                              return _c("div", { key: index }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(err) +
                                    "\n          "
                                )
                              ])
                            })
                          )
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "download-excel",
                {
                  staticClass: "float-to-right m__t--30",
                  attrs: { data: _vm.error_data, name: "flow-data-error.xls" }
                },
                [
                  _c("b-button", { staticClass: "btn green" }, [
                    _vm._v("\n          Export Error\n        ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("jProgressScreen", {
        ref: "ImportFile",
        attrs: {
          "data-kirim": _vm.data_import,
          "url-api": _vm.url,
          headers: _vm.headers
        },
        on: { finish: _vm.uploadDone }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23a02659", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a02659","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/jImportFlows.vue
// module id = null
// module chunks = 